interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  className?: string;
}

export function Skeleton({
  width = '100%',
  height = '1em',
  borderRadius = '4px',
  className = '',
}: SkeletonProps) {
  return (
    <div
      className={`skeleton ${className}`}
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        borderRadius: typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius,
      }}
    />
  );
}

export function TranscriptSkeleton() {
  return (
    <div className="timeline-item">
      <div className="timeline-time">
        <Skeleton width={60} height={14} />
      </div>
      <div className="timeline-content">
        <Skeleton height={16} className="skeleton-mb" />
        <Skeleton width="80%" height={16} className="skeleton-mb" />
        <div className="timeline-meta">
          <Skeleton width={120} height={12} />
        </div>
      </div>
    </div>
  );
}

export function CardSkeleton({ lines = 3 }: { lines?: number }) {
  return (
    <div className="card">
      <Skeleton width="40%" height={20} className="skeleton-mb" />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} width={`${100 - i * 10}%`} height={14} className="skeleton-mb" />
      ))}
    </div>
  );
}

export function MetricCardSkeleton() {
  return (
    <div className="metric-card">
      <Skeleton width={80} height={12} className="skeleton-mb" />
      <Skeleton width={60} height={32} />
    </div>
  );
}
